<template>
  <div class="flex items-center relative text-hex-fff h-53px">
    <img
      class="absolute z-10"
      :src="require(`../../../assets/images/metal/statistics/${statisticData.img}.png`)"
      alt=""
    />
    <div
      :style="{
        backgroundImage: `url(${require(`../../../assets/images/metal/statistics/${backgroundType}.png`)})`,
      }"
      class="info-bg ml-23px w-[calc(100%-23px)] pl-30px relative h-30px flex flex-col justify-end"
    >
      <p class="text-20px absolute -top-10px metal-number">{{ statisticData.value }}</p>
      <p class="pb-4px w-full truncate" :class="textFontSize">
        {{ statisticData.label }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiyStatistic',
  props: {
    backgroundType: {
      type: String,
      // metalLongBackground 长背景 metalShortBackground 短背景
      default: 'metalLongBackground',
    },
    statisticData: {
      type: Object,
      default: () => {},
    },
    textFontSize: {
      type: String,
      default: 'text-12px',
    },
  },
}
</script>

<style lang='scss' scoped>
.info-bg {
  background-position: 100% 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.metal-number {
  font-family: 'Ysbth';
  background-image: linear-gradient(to top, #24b5c9, #c4eded);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
